import { render, staticRenderFns } from "./CrazyTown.vue?vue&type=template&id=f7349d82&scoped=true&"
import script from "./CrazyTown.vue?vue&type=script&lang=js&"
export * from "./CrazyTown.vue?vue&type=script&lang=js&"
import style0 from "./CrazyTown.vue?vue&type=style&index=0&id=f7349d82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7349d82",
  null
  
)

export default component.exports